export class ApaciDTO {
  idAde: string;

  descrizione: string;
}
